import { useEffect } from "react";

let speechWarmedUp = false;

const useSpeechSynthesis = () => {
  useEffect(() => {
    if (speechWarmedUp) return;

    const handleFirstUserInteraction = () => {
      if (!window.speechSynthesis) return;

      speechWarmedUp = true;

      // Clear queue
      window.speechSynthesis.cancel();

      // Empty Utterance
      const utterance = new SpeechSynthesisUtterance("\u200B"); // invisible char
      utterance.volume = 0; // silence
      utterance.rate = 1;
      utterance.pitch = 1;

      window.speechSynthesis.speak(utterance);

      utterance.onend = () => {
        window.removeEventListener("click", handleFirstUserInteraction);
        window.removeEventListener("touchstart", handleFirstUserInteraction);
        window.removeEventListener("pointerdown", handleFirstUserInteraction);
        window.removeEventListener("keydown", handleFirstUserInteraction);
      };
    };

    window.addEventListener("click", handleFirstUserInteraction);
    window.addEventListener("touchstart", handleFirstUserInteraction);
    window.addEventListener("pointerdown", handleFirstUserInteraction);
    window.addEventListener("keydown", handleFirstUserInteraction);

    return () => {
      window.removeEventListener("click", handleFirstUserInteraction);
      window.removeEventListener("touchstart", handleFirstUserInteraction);
      window.removeEventListener("pointerdown", handleFirstUserInteraction);
      window.removeEventListener("keydown", handleFirstUserInteraction);
    };
  }, []);
};

export default useSpeechSynthesis;
